/// <amd-module name="VSSUI/Components/List/ListDropIndicator" />
import * as React from "react";
import { css } from "VSSUI/Util";
import { IListDropIndicatorProps } from "./ListDropIndicator.Props";

export function ListDropIndicator(props: IListDropIndicatorProps) {
    const { position, xOffset, lineOffset } = props;
    const circleLeft = (xOffset || 0) + "px";
    const lineLeft = (lineOffset || 0) + "px";
    const positionClassName = position;
    return (
        <>
            <div className={css("bolt-list-drop-indicator-line flex-grow absolute", positionClassName)} style={{ left: lineLeft }} />
            <div className={css("bolt-list-drop-indicator-circle absolute", positionClassName)} style={{ left: circleLeft }} />
        </>
    );
}
